import styled from "styled-components";
export const CalendarBox = styled.section `
	width: 18.75rem;
	background-color: #fff;
	padding: 1.875rem 0.75rem 0.75rem 0.75rem;
	border-radius: 4px;
	.text {
		padding: 0 0.625rem;
		color: #333;
		font-size: 0.9375rem;
		font-family: var(--fontRegular);
		font-weight: 400;
		line-height: 1.125rem;
		word-break: break-word;
		text-align: center;
	}
	.btns {
		margin-top: 1.875rem;
		display: flex;
		justify-content: space-between;
		> div {
			width: 8.25rem;
			height: 2.5rem;
			text-align: center;
			line-height: 2.5rem;
			font-size: 0.875rem;
			font-weight: 400;
			font-family: var(--fontRegular);
			border-radius: 2px;
		}
		> div:first-child {
			color: #666;
			border: 1px solid #999;
		}
		> div:last-child {
			background: #ff5a00;
			color: #fff;
		}
	}
`;
